// extracted by mini-css-extract-plugin
export default {"list":"OrderBriefingDocs_list__FuWf+","selected":"OrderBriefingDocs_selected__TnpjG","actionItem":"OrderBriefingDocs_actionItem__AUzSX"};